import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Spinner from 'shopper/components/Spinner';

const InteractionsListSpinner = ({ className, ...rest }) => (
  <div
    className={twMerge('flex items-center justify-center', className)}
    {...rest}
  >
    <Spinner />
  </div>
);

InteractionsListSpinner.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default InteractionsListSpinner;
